import FindPeople from './FindPeople';

export default FindPeople; 